import React, { useState } from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
import { NavLink } from "react-router-dom";
import SideNav from './../../../components/SideNav_RI';
import PacientList from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Pacientes_Lista';

export default function RI_PacientesLista() {
    //let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [pacients,setPacients] = useState(false);
    return (
        <>
            <SideNav />
           <div id="top-RI-Cadastro"></div>
            <div id="main-RI-ListaPacientes">
                    <p id="RI-ListaPacientes">Ações</p>
                    <hr id="divider-RI-ListaPacientes" />
                    <div id="arrow-RI-ListaPacientes">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-RI-ListaPacientes"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-RI-ListaPacientes">
                           <div id="ListaDeAcoes-RI-ListaPacientes">
                                <NavLink to="/RI_PacientesCadastro"><button id="RI-ListaPacientes">Cadastrar pacientes</button></NavLink>
                           </div>
                        </div>
                    </Collapse>
                    <p id="RI-ListaPacientes">Lista de pacientes</p>
                    <hr id="divider-RI-ListaPacientes" />
                    <div id="arrow-RI-ListaPacientes">
                        <IoIosArrowDown
                            onClick={() =>
                                setPacients(!pacients)
                            }
                            size={"6vh"}
                            id="IconDown-RI-ListaPacientes"
                        />
                    </div>
                    <Collapse isOpened={pacients}>
                        <div id="collapsed-RI-ListaPacientes">
                           <div id="ListaDePacientes-RI-ListaPacientes">
                                <PacientList />
                           </div>
                        </div>
                    </Collapse>
            </div>
        </>
    );
}